export const STATUS_MAP = [
  {
    style: { color: '#F5603F', backgroundColor: '#FFECE8' },
    status: [
      'manual_end',
      'revoker',
      'revoker_to_start',
      'backToStart',
      'reject',
    ],
  },
  {
    style: { color: '#0EB400', backgroundColor: '#E8FFEA' },
    status: ['delivertoAgree', 'agree', 'approveLineAgree'],
  },
  {
    style: { color: '#7D72FF', backgroundColor: '#EEEDFF' },
    status: ['deliverto', 'user_add_sign_back', 'addsign'],
  },
  {
    style: { color: '#FF8A00', backgroundColor: '#FFF7E8' },
    status: ['awaiting_check'],
  },
  {
    style: { color: '#0560FD', backgroundColor: '#E9F1FF' },
    status: ['start_commu', 'start', 'copyto_reply', 'inqu_reply'],
  },
  {
    style: { color: '#00C6A3', backgroundColor: '#E8FFFB' },
    status: ['copyto'],
  },
]
